module.exports = __webpack_public_path__ + "img/unionpay.56f7357d.svg";